"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLinePriority = void 0;
var LeadServiceLinePriority;
(function (LeadServiceLinePriority) {
    LeadServiceLinePriority[LeadServiceLinePriority["Level 1"] = 0] = "Level 1";
    LeadServiceLinePriority[LeadServiceLinePriority["Level 2"] = 1] = "Level 2";
    LeadServiceLinePriority[LeadServiceLinePriority["Level 3"] = 2] = "Level 3";
    LeadServiceLinePriority[LeadServiceLinePriority["Level 4"] = 3] = "Level 4";
    LeadServiceLinePriority[LeadServiceLinePriority["Level 5"] = 4] = "Level 5";
})(LeadServiceLinePriority = exports.LeadServiceLinePriority || (exports.LeadServiceLinePriority = {}));
//# sourceMappingURL=LeadServiceLinePriority.js.map